import { useEffect, useMemo, useState } from "react";
import { PageLoader } from "../../../components/loader/pageLoader";
import { useLocation, useParams } from "react-router";
import { ProgressLine } from "../../../components/progressLine/progressLine";
import { ImageGrid } from "../../../components/imageGrid/imageGrid";
import { Button } from "../../../components/button/button";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { RawTextPreview } from "../../../components/rawTextPreview/rawTextPreview";
import CheckListAPI from "../../../api/CheckListAPI";
import qs from "qs";

import styles from "./checklistTaskPage.module.css";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { Separator } from "../../../components/separator/separator";

import { Text } from "../../../components/text/text";

const htmlTextLength = (html) => {
    const container = document.createElement('div');
    container.innerHTML = html;

    return container.innerText.length;
}

const priorities = ["низкий", "средний", "высокий"];

export const SuperAdminWorkerChecklistTaskPage = () => {
    const { taskId, cafeId, userId } = useParams();

    const [taskData, setTaskData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [images, setImages] = useState([]);

    const { search } = useLocation();
    const tabId = qs.parse(search.replace("?", "")).initialTab || "bar";
    const openPage = useOpenPage();

    useEffect(() => {
        CheckListAPI
            .fetchUserTaskData(userId, taskId)
            .catch(console.error)
            .then(data => {
                setTaskData(data);
                return CheckListAPI.fetchUserTaskImages(userId, taskId);
            })
            .catch(console.error)
            .then(setImages)
            .finally(() => setLoading(false));
    }, [userId, taskId]);

    const noteLength = useMemo(() => htmlTextLength(taskData?.note), [taskData?.note]);

    if (loading || taskData === null) {
        return <PageLoader />;
    }

    return (
        <>
            <AdminHeader
                title={
                    <div className={styles.title}>
                        <span>Задача</span>
                        <ProgressLine progress={0.1 + 0.9 * (taskData.countDone / taskData.countTotal)} height="4px" />
                    </div>
                }
                userId={userId}
            />

            <div className={styles.task}>
                <div className={styles.task_description}>
                    Статус: {
                        taskData.countTotal === 1 ?
                            (taskData.countDone === taskData.countTotal ? "выполнено" : "не выполнено") :
                            (`выполнено ${taskData.countDone} / ${taskData.countTotal}`)
                    } <br />
                    Приоритет: {priorities[taskData.priority]}
                </div>
                <Text as="div" variant="body" className={styles.task_text} size={16} weight={700} lineHeight="1.1">
                    {taskData.taskText}
                </Text>
            </div>

            {
                taskData.note && noteLength !== 0 &&
                <div className={styles.task_note_container}>
                    <Text as="div" variant="caption" className={styles.task_note_label} >Заметки</Text>
                    <RawTextPreview text={taskData.note} />
                </div>
            }

            {
                images && images.length !== 0 &&
                <div className={styles.images_container}>
                    <Text as="div" variant="h3" className={styles.images_title} size={12}>Изображения</Text>
                    <ImageGrid
                        images={images}
                    />
                </div>
            }

            <Separator />

            <Button
                fixed
                text="Вернуться к задачам"
                onClick={openPage(`/superadmin/cafe/${cafeId}/employees/${userId}/tasks?initialTab=${tabId}`)}
            />
        </>
    );
}